import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import { Col, Divider, Row, Skeleton } from 'antd';
import { HighchartsReact } from 'highcharts-react-official';
import { requestPost } from '../../hooks/Request/Request';

const initialOptions = {
    chart: {
        type: "bar",
        //height: "220px"
    },
    title: null,
    xAxis: {
        categories: ["Área Homogénea", "Municipio"],
    },
    yAxis: {
        min: 0,
        title: {
            text: "% Activos por Calificación",
        },
        labels: {
            enabled: false // Desactivar los números en el eje x
        },
        pointPadding: 0.01,
        reversed: false,
    },
    accessibility: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    legend: {
        reversed: true,
        itemStyle: {
            fontSize: '9px'
        },
    },
    plotOptions: {
        series: {
            stacking: "normal",
            pointWidth: 10,
            dataLabels: {
                enabled: true,
                y: -15
            }
        },
        bar: {
            dataLabels: {
                enabled: true,
                format: '{y:.0f}%'
            },
        }
    },
    series: [
        {
            name: "D",
            data: [null,null],
            color: '#490000',
            states: {
                hover: {
                  brightness: 0, // Mantener el mismo brillo al hacer hover
                  halo: {
                    opacity: 0 // Ocultar el halo al hacer hover
                  }
                },
                select: {
                  color: '#4c7f22',
                  borderColor: '#4c7f22',
                  brightness: 0, // Mantener el mismo brillo al seleccionar
                  halo: {
                    opacity: 0 // Ocultar el halo al seleccionar
                  }
                }
              },
        },
        {
            name: "C",
            data: [null,null],
            color: '#880000',
        },
        {
            name: "CC",
            data: [null,null],
            color: '#c80000'
        },
        {
            name: "CCC",
            data: [null,null],
            color: '#f40800'
        },
        {
            name: "B-",
            data: [null,null],
            color: '#f52300'
        },
        {
            name: "B",
            data: [null,null],
            color: '#f73e00'
        },
        {
            name: "B+",
            data: [null,null],
            color: '#f85900'
        },
        {
            name: "BB-",
            data: [null,null],
            color: '#fa7300'
        },
        {
            name: "BB",
            data: [null,null],
            color: '#fb8e00'
        },
        {
            name: "BB+",
            data: [null,null],
            color: '#fda900'
        },
        {
            name: "BBB-",
            data: [null,null],
            color: '#fec400'
        },
        {
            name: "BBB",
            data: [null,null],
            color: '#ffdf00'
        },
        {
            name: "BBB+",
            data: [null,null],
            color: '#e3d407'
        },
        {
            name: "A-",
            data: [null,null],
            color: '#c3c50f'
        },
        {
            name: "A",
            data: [null,null],
            color: '#a4b617'
        },
        {
            name: "A+",
            data: [null,null],
            color: '#84a720'
        },
        {
            name: "AA-",
            data: [null,null],
            color: '#659928'
        },
        {
            name: "AA",
            data: [null,null],
            color: '#4c7f22'
        },
        {
            name: "AA+",
            data: [null,null],
            color: '#34641c'
        },
        {
            name: "AAA",
            data: [null,null],
            color: '#1c4a16'
        },
    ],
};

function GraficoEcon({dataa, loading, setLoading, setAreaMunData}) {
    const refCat = dataa.data[0].full_refcat;
    const [options, setOptions] = useState(initialOptions);
    


    function redondearNumero(numero) {
        var entero = Math.floor(numero); 
        
        var decimal = numero - entero; 
        
        if (decimal >= 0.50001) {
          entero++; 
        }
        
        return entero;
      }

    const controller = new AbortController()
    const signal = controller.signal
    useEffect(() => {
        setLoading(true);
        async function fetchData() {
            setOptions(prevOptions => ({
                ...prevOptions,
                series: []
            }));
            const result = await requestPost(
                'https://terminal.veltisrating.com:8888/api/getBarrioMunicipioDistRating',
                { refcat: dataa.data[0].full_refcat },
                signal
            );

            let dataBarrio = result.data.barrio;
            const sumaCntBarrio = dataBarrio.reduce((total, dato) => total + parseInt(dato.cnt), 0);

            let dataMunicipio = result.data.municipio;
            const sumaCntMunicipio = dataMunicipio.reduce((total, dato) => total + parseInt(dato.cnt), 0);

            const ratingMap = {
                19: 'AAA',
                18: 'AA+',
                17: 'AA-',
                16: 'AA',
                15: 'A+',
                14: 'A',
                13: 'A-',
                12: 'BBB+',
                11: 'BBB',
                10: 'BBB-',
                9: 'BB+',
                8: 'BB',
                7: 'BB-',
                6: 'B+',
                5: 'B',
                4: 'B-',
                3: 'CCC',
                2: 'CC',
                1: 'C',
                0: 'D'
            };

            dataBarrio.forEach(dato => {
                const porcentaje = (parseInt(dato.cnt) / sumaCntBarrio) * 100;
                dato.cnt = redondearNumero(porcentaje);
                const rating = ratingMap[dato.rating_parcela];
                dato.rating_parcela = rating;
            });
          
            dataMunicipio.forEach(dato => {
                const porcentaje = (parseInt(dato.cnt) / sumaCntMunicipio) * 100;
                dato.cnt = redondearNumero(porcentaje);
                const rating = ratingMap[dato.rating_parcela];
                dato.rating_parcela = rating;
            });

            const updatedSeriesData = options.series.map(series => {
                const matchingDatoBarrio = dataBarrio.find(dato => dato.rating_parcela === series.name);
                const matchingDatoMunicipio = dataMunicipio.find(dato => dato.rating_parcela === series.name);

                const updatedData = [
                    matchingDatoBarrio ? parseInt(matchingDatoBarrio.cnt) : null,
                    matchingDatoMunicipio ? parseInt(matchingDatoMunicipio.cnt) : null
                ];

                return { ...series, data: updatedData };
            });

            setAreaMunData(updatedSeriesData);

            setOptions(prevOptions => ({
                ...prevOptions,
                series: updatedSeriesData
            }));
            if(result.response === 200){
                setLoading(false);
            }
        }

        if (refCat !== null) {
            
            fetchData();
        }
        return () => controller.abort()
    }, [refCat]);

    if (loading) {
        return (
            <div style={{display: 'flex', gap: '5px', marginTop: '5%', marginLeft: '2%'}}>
                <Skeleton 
                    active 
                    loading={loading} 
                    paragraph={{
                        rows: 3,
                    }}
                />
            </div>
        )
    } else {
    return (
        <div style={{ width: '100%' }}>
            <Divider orientation="left">Distribución Rating Entorno</Divider>

            <Row>
                <Col flex="1 1 auto" style={{ height: 220, width: '100%' }}>
                    <HighchartsReact
                        containerProps={{ style: { height: "100%" } }}
                        highcharts={Highcharts}
                        options={options}
                    />
                </Col>
            </Row>
        </div>
    );
}}

export default GraficoEcon;